import { RealEstateStatusEnum } from '@app-type/RealEstateEnum';

export interface RealEstateItem {
	id: RealEstateItemKey;
	listing: RealEstateListing;
}

export interface RealEstateItemKey {
	clientId: string;
	groupId: string;
	integrationConfigId: string;
	provider: string;
	listingId: string;
}

export interface RealEstateListing {
	id: string;
	price: number;
	bedrooms: number;
	bathrooms: string;
	sqft: number;
	city: string;
	stateAbbr: string;
	zipCode: string;
	address: string;
	imgUrls: string[];
	createdAt: Date;
	lastModifiedAt: Date;
	title: string;
	description: string;
	url: string;
	productOwnUrl: boolean;
	lease: boolean;
	leaseAmountFrequency?: string;
	latitude?: number;
	longitude?: number;
}

export enum SaleLeaseOptions {
	ONLY_SALE = 'ONLY_SALE',
	ONLY_LEASE = 'ONLY_LEASE',
	ALL = 'ALL'
}

export enum RealEstateDaysOnMarketEnum {
	ANY = 'ANY',
	LAST_24_HOURS = 'LAST_24_HOURS',
	LAST_7_DAYS = 'LAST_7_DAYS',
	LAST_14_DAYS = 'LAST_14_DAYS',
	LAST_30_DAYS = 'LAST_30_DAYS',
	PLUS_30_DAYS = 'PLUS_30_DAYS'
}

export enum RealEstateSpecialListingConditionsEnum {
	STANDARD = 'STANDARD',
	PROBATE_LISTING = 'PROBATE_LISTING',
	REAL_ESTATE_OWNED = 'REAL_ESTATE_OWNED',
	SHORT_SALE = 'SHORT_SALE',
	AUCTION = 'AUCTION',
	GOVERNMENT_OWNED = 'GOVERNMENT_OWNED',
	THIRD_PARTY_APPROVAL = 'THIRD_PARTY_APPROVAL',
	IN_FORECLOSURE = 'IN_FORECLOSURE',
	HUD_OWNED = 'HUD_OWNED',
	LEASE = 'LEASE',
	SALE = 'SALE'
}

export enum PropertyType {
	RESIDENTIAL = 'RESIDENTIAL',
	COMMERCIAL = 'COMMERCIAL',
	LAND = 'LAND'
}

export enum PropertySubType {
	SINGLE_FAMILY_RESIDENCE = 'SINGLE_FAMILY_RESIDENCE',
	APARTMENT = 'APARTMENT',
	CONDOMINIUM = 'CONDOMINIUM',
	TOWNHOUSE = 'TOWNHOUSE',
	VILLA = 'VILLA',
	ONE_TWO_DUPLEX = 'ONE_TWO_DUPLEX',
	DUPLEX = 'DUPLEX',
	TRIPLEX = 'TRIPLEX',
	QUADRUPLEX = 'QUADRUPLEX',
	MANUFACTURED_HOME = 'MANUFACTURED_HOME',
	MODULAR_HOME = 'MODULAR_HOME',
	FARM = 'FARM',
	CONDO_HOTEL = 'CONDO_HOTEL',
	MULTI_FAMILY = 'MULTI_FAMILY',
	GARAGE_CONDO = 'GARAGE_CONDO',
	MOBILE_HOME = 'MOBILE_HOME',
	DOCK_RACKOMINIUM = 'DOCK_RACKOMINIUM',
	BUSINESS = 'BUSINESS',
	RETAIL = 'RETAIL',
	RESTAURANT = 'RESTAURANT',
	WAREHOUSE = 'WAREHOUSE',
	OFFICE = 'OFFICE',
	MIXED_USE = 'MIXED_USE',
	INDUSTRIAL = 'INDUSTRIAL',
	ASSEMBLY_BUILDING = 'ASSEMBLY_BUILDING',
	AGRICULTURE = 'AGRICULTURE',
	OTHER = 'OTHER',
	HOTEL_MOTEL = 'HOTEL_MOTEL',
	UNIMPROVED_LAND = 'UNIMPROVED_LAND'
}

export interface RealEstateFilter {
	locationRadius?: string; // search radius in miles — used with latitude/longitude
	locationCity?: string; // city name for city-mode search, e.g. "Austin"
	locationState?: string; // state abbreviation for city-mode search, e.g. "TX"
	latitude?: number; // geographic latitude for coords-mode search
	longitude?: number; // geographic longitude for coords-mode search
	priceRangeMin?: number;
	priceRangeMax?: number;
	minLivingArea?: number;
	maxLivingArea?: number;
	minBedrooms?: number;
	minBathrooms?: number;
	minYearBuilt?: number;
	maxYearBuilt?: number;
	propertyType?: PropertyType[];
	propertySubTypes?: PropertySubType[];
	onlyMyListings?: boolean;
	listingId?: string;
	saleLeaseOptions?: SaleLeaseOptions;
	integrationConfigId?: string;

	locationLabel?: string; // display text for coords-mode location, used to repopulate the picker
	propertyStatus?: RealEstateStatusEnum[];
	specialListingConditions?: RealEstateSpecialListingConditionsEnum[];
	listOfficeNames?: string[];
	features?: string[];
	sellerFinancing?: boolean;
	daysOnMarket?: RealEstateDaysOnMarketEnum;
	shortTermRentalAllowed?: boolean;
}

export interface PropertyFeatureContent {
	title: string;
	content: string | number | boolean;
}

export interface PropertyFeature {
	title: string;
	content: PropertyFeatureContent[];
}
